module.exports = __webpack_public_path__ + "img/whatsapp-marca-0-l20.4e75d732.svg";